import { useMutation } from "react-query";
import fileuploadService from "../services/fileuploadService";
import dashboardService from "../services/dashboardService";

const useSuperAdminDashboard = (onData) => {
  return useMutation(dashboardService.superAdminDashboard, {
    onSuccess: (data) => onData(data),
  });
};

const dashboardQueries = {
  useSuperAdminDashboard
};

export default dashboardQueries;
